import './styles/tailwind.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ui/ErrorBoundary';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const reloadApp = async () => {
  try {
    if (window.desktopApi?.restartApp) {
      await window.desktopApi.restartApp();
      return;
    }
  } catch {}
  try {
    window.location.reload();
  } catch {}
};

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={
      <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',flexDirection:'column',color:'#475569'}}>
        <div style={{fontWeight:700,marginBottom:8}}>Произошла ошибка интерфейса</div>
        <button onClick={() => { void reloadApp(); }} style={{padding:'8px 12px',border:'1px solid #e2e8f0',borderRadius:8,background:'#fff',cursor:'pointer'}}>Перезагрузить</button>
      </div>
    }>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);